export const convertClientValuesToDataModel = (values: any, termsOfUse: any, privacyPolicy: any) => ({
  firstName: values.firstName || undefined,
  lastName: values.lastName || undefined,
  email: values.email || undefined,
  stage: values.stage ? { id: values.stage.value, value: values.stage.label } : undefined,
  interests: !!values.interests?.length
    ? values.interests.map((interest: any) => ({ id: interest.value, value: interest.label }))
    : undefined,
  termsAccepted: values.termsAccepted,
  signedDocuments: values.termsAccepted
    ? [
        {
          name: termsOfUse && termsOfUse?.name,
          version: termsOfUse && termsOfUse?.version,
        },
        {
          name: privacyPolicy && privacyPolicy?.name,
          version: privacyPolicy && privacyPolicy?.version,
        },
      ]
    : undefined,
});
